<template>
  <div>
    <v-layout row v-if="error">
      <v-flex xs12 sm8 offset-sm2>
        <app-alert @dismissed="dismiss" :text="error.message"></app-alert>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12 sm10 offset-sm1 md6 offset-md3>
        <h2 class="display-1 expired-link mb-3" v-if="expiredLink">The reset link you clicked has expired. Please request a new one.</h2>
        <h3 class="headline mb-3">Forgot your password?</h3>
        <p>Not a problem. Enter your email address below and we'll send you password reset instructions.</p>
        <v-card light class="mb-5">
          <v-card-text>
            <!-- <v-container> -->
              <v-form 
                @submit.prevent="onSubmit"
                v-model="valid"
                ref="form"
                lazy-validation                
              >
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="email"
                      label="Email"
                      id="email"
                      v-model="email"
                      type="email"
                      :rules="[rules.required, rules.email]"
                      required>
                    </v-text-field>
                  </v-flex>
                </v-layout>               
                <v-layout row align-top>
                  <v-flex xs6 class="text-xs-left">
                    <v-btn
                      @click="goBack"
                      class="ml-0"
                      outline
                      color="secondary"
                    >&laquo; Back</v-btn>
                  </v-flex>
                  <v-flex xs6 class="text-xs-right">
                    <v-btn outline primary type="submit" :loading="loading" :disabled="loading === true || valid === false" class="mr-0">
                      Send
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-form>
            <!-- </v-container> -->
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { HTTP } from '@/http-common'
  export default {
    props: {
      expired: {
        required: false,
        type: Number
      }
    },
    data () {
      return {
        valid: true,
        loading: false,
        expiredLink: false,
        email: '',
        password: '',
        rules: {
          required: (v) => {
            return !!v || 'Required'
          },
          email: (v) => {
            if (this.brand.rules.email) {
              return this.brand.rules.email(v)
            } else {
              return /^\w+([.+-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
            }
          }
        }
      }
    },
    mounted () {
      if (this.$route.query.expired && parseInt(this.$route.query.expired) === 1) {
        this.expiredLink = true
      }
    },
    computed: {
      user () {
        return this.$store.getters.user
      },
      error () {
        return this.$store.getters.error
      }
    },
    watch: {
      user (value) {
        if (value !== null && value !== undefined) {
          this.$router.push('/')
        }
      }
    },
    methods: {
      goBack () {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push('/')
      },
      onSubmit () {
        if (this.$refs.form.validate()) {
          this.loading = true
          this.dismiss()

          HTTP.post('/forgot-password', {
            email: this.email
          })
          .then(response => {
            this.loading = false
            if (response.status === 200) {
              this.$router.push({ name: 'reset-email-sent' })
            }
          })
          .catch(e => {
            this.loading = false
            console.error(e)
          })
        } else {
          console.log('invalid...')
        }
      },
      dismiss () {
        this.$store.dispatch('clearError')
      }
    }
  }
</script>

<style scoped>
  .expired-link {
    color: #E53935;
    font-weight: light;
  }
</style>


// WEBPACK FOOTER //
// src/components/user/ForgotPassword.vue